import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { EventCategoryListResponseDto } from '@whetstoneeducation/hero-common';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppEventService } from '../events.service';

@Injectable({ providedIn: 'root' })
export class AppEventCategoryListResolver extends BaseResolver<{
  eventCategories: EventCategoryListResponseDto[];
}> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public eventsService: AppEventService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve() {
    return this.eventsService.getEventCategoriesListResolverData();
  }
}
